<template>
    <div class="checkResult" tabindex="0">
        <div class="checkResult__copy-container">
            <h1 class="title checklist-title">
                {{ $t('checkResult:resultPage.keyLine') }}
            </h1>
            <p class="description" v-html="$t('checkResult:resultPage.infoLine')"></p>

            <div class="vue-slider-wrapper quizzer">
                <vue-slider v-model="successionResult" v-bind="sliderOptions">
                </vue-slider>
            </div>
            <div class="checkResult__status">
                <h3 class="checklist-status">{{ $t('checkResult:message.point'+successionResult+'.label') }}</h3>
                <p class="status-track">{{ $t('checkResult:message.point'+successionResult+'.info') }}</p>
            </div>
        </div>
        <div class="checkResult__form-intro">
            <h4 class="form-info">{{ $t('checkResult:resultPage.moreDetails') }}</h4>
        </div>
        <ContactUsForm/>
    </div>
</template>

<script>
import adobeTracking from '@/mixins/adobeTracking'
import ContactUsForm from '@/components/form/ContactUsForm'
import vueSlider from 'vue-slider-component'
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'Result',
    data: function() {
        return {
            successionResult: 4,
            sliderOptions: {
                dotSize: 26,
                tooltip: 'none',
                direction: 'ltr',
                hideLabel: true,
                marks: true,
                min: 1,
                max: 13,
                height: 15,
                clickable: false
            }
        }
    },
    mixins: [adobeTracking],
    components: {
        ContactUsForm,
        vueSlider,
        SvgIcon
    },
    mounted() {
        this.trackCTAClick({
            CTAName: 'Show results',
            CTALink: 'resultForm'
        })
        document.querySelector('.checkResult').focus()
        this.successionResult = Object.values(this.resultsOperational).reduce((total, obj) => obj.point + total, 0) +
                            Object.values(this.resultsStructural).reduce((total, obj) => obj.point + total, 0) +
                            Object.values(this.resultsEmotional).reduce((total, obj) => obj.point + total, 0) +
                            Object.values(this.resultsSustainable).reduce((total, obj) => obj.point + total, 0)

        if (this.successionResult >= 6 && this.successionResult <= 9) {
            this.successionResult = 7
        } else if (this.successionResult >= 10 && this.successionResult <= 13) {
            this.successionResult = 10
        } else {
            this.successionResult = 4
        }
    },
    computed: {
        resultsOperational() {
            return this.$store.getters['answers/operational']
        },
        resultsStructural() {
            return this.$store.getters['answers/structural']
        },
        resultsEmotional() {
            return this.$store.getters['answers/emotional']
        },
        resultsSustainable() {
            return this.$store.getters['answers/sustainable']
        }
    }
}
</script>
